import api from "@/api/api";

export const getSyncTask = () => {
  return api.get(`/canvas/sso/sync-tasks`);
};

export const updateSyncTask = (syncTaskId, payload) => {
  return api.patch(`/canvas/sso/sync-tasks/${syncTaskId}`, payload);
};

export const deleteSyncTask = (syncTaskId) => {
  return api.delete(`/canvas/sso/sync-tasks/${syncTaskId}`);
};
